import { encodeAvailabilityRule, getAvailabilityRuleReferenceAttributes } from 'components/availability/form/utils'

const getHolidayAttributes = (holidays) => {
  const holidaysAttributes = (holidays || [])
    .filter((holiday) => !holiday.enabled)
    .map((holiday) => ({ id: holiday.id, enabled: holiday.enabled }))

  return {
    _destroy: holidaysAttributes.length === 0,
    holidays: holidaysAttributes
  }
}

const getMemberData = ({
  usingCustomHours,
  userUuid,
  userId,
  memberId,
  customRuleId,
  availableHours,
  dateOverrides,
  timezone,
  usingSecondarySchedule,
  activeAvailabilityRuleId,
  doubleBookingRules,
  defaultHoursId,
  enabled,
  deleted,
  holidays
}) => {
  let availabilityRuleId = defaultHoursId

  if (usingCustomHours) {
    availabilityRuleId = customRuleId
  }

  if (usingSecondarySchedule) {
    availabilityRuleId = activeAvailabilityRuleId
  }

  if (activeAvailabilityRuleId === 'default') {
    availabilityRuleId = null
  }

  const attributes = {
    user_id: userId,
    user_uuid: userUuid,
    enabled,
    holiday_set_attributes: getHolidayAttributes(holidays),
    _destroy: deleted,
    availability_rule_reference_attributes: getAvailabilityRuleReferenceAttributes(availabilityRuleId, doubleBookingRules),
    availability_rule_attributes: {
      id: customRuleId,
      ...encodeAvailabilityRule(availableHours, dateOverrides, timezone)
    }
  }
  if (!String(memberId).startsWith('NEW')) {
    attributes.id = memberId
  }

  return attributes
}

const getMemberDataV4 = ({
  usingCustomHours,
  userUuid,
  userId,
  memberId,
  customRuleId,
  availableHours,
  dateOverrides,
  timezone,
  activeAvailabilityRuleId,
  doubleBookingRules,
  enabled,
  deleted,
  organizationInvitationId,
  organizationInvitationUuid,
  defaultHoursId,
  usingSecondarySchedule
}) => {
  let availabilityRuleId = defaultHoursId

  if (usingSecondarySchedule) {
    availabilityRuleId = activeAvailabilityRuleId
  }

  if (usingCustomHours) {
    availabilityRuleId = customRuleId
  }

  if (activeAvailabilityRuleId === 'default') {
    availabilityRuleId = null
  }

  const attributes = {
    user_id: userId,
    user_uuid: userUuid,
    organization_invitation_id: organizationInvitationId,
    organization_invitation_uuid: organizationInvitationUuid,
    enabled,
    _destroy: deleted,
    availability_rule_reference_attributes: getAvailabilityRuleReferenceAttributes(availabilityRuleId, doubleBookingRules),
    ...(usingCustomHours ? {
      availability_rule_attributes: {
        id: customRuleId,
        ...encodeAvailabilityRule(availableHours, dateOverrides, timezone)
      }
    } : {})
  }
  if (!String(memberId).startsWith('NEW')) {
    attributes.id = memberId
  }

  return attributes
}

const memberToServerData = (member) => (getMemberData(member))
const memberToServerDataV3 = (member) => (getMemberDataV4(member))

export const membersToServerData = (members) => ({
  event_type_memberships_attributes: members.map(memberToServerData)
})

export const membersToServerDataV3 = (members) => ({
  event_type_memberships_attributes: members.map(memberToServerDataV3)
})
